import React from 'react'
import { Card } from 'antd'
import { useParams } from 'react-router'
import ConfidenceDistributionChart from './ConfidenceDistributionChart'

const ConfidenceDistributionCard = () => {
    const { token } = useParams()

    return (
        <Card title='Confidence Distribution'>
            <ConfidenceDistributionChart token={token} />
        </Card>
    )
}

export default ConfidenceDistributionCard
